const data = {
  github: 'https://github.com/ebrakke',
  linkedin: 'https://www.linkedin.com/in/ebrakke/',
  email: null,
}

export default data
